import { useContext, useEffect, useState } from 'react'
import LoadingSplash from '../layout/LoadingSplash'
import { ServiceContext } from '@confer/lib'
import { useNavigate } from 'react-router-dom'

export default function RestorePage() {
  const { databaseService, userService } = useContext(ServiceContext)
  const navigate = useNavigate()
  const urlParams = new URLSearchParams(window.location.search)
  const restoreSubmissionId = urlParams.get('sub')
  const restoreCode = urlParams.get('code')
  const restoreSurveyId = urlParams.get('survey')
  const restoreRoute = urlParams.get('route') ?? restoreSurveyId
  const surveyParams = new URLSearchParams()
  for (const key of ['id', 'groupid']) {
    for (const value of urlParams.getAll(key)) surveyParams.append(key, value)
  }
  const surveyQuery = surveyParams.toString()

  const [userReady, setUserReady] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const sub = userService.observeUser().subscribe(async (u) => {
      if (u.initialised && !u.user) {
        await userService.createAnonymousUser()
      }
      if (u.initialised && u.user) {
        setUserReady(true)
      }
    })
    return () => sub.unsubscribe()
  }, [userService])

  useEffect(() => {
    const claim = async () => {
      if (restoreSubmissionId && restoreCode && restoreSurveyId && restoreRoute && userReady) {
        const { success, error } = await databaseService.claimSubmission(
          restoreSurveyId,
          restoreSubmissionId,
          restoreCode,
        )
        if (success) {
          sessionStorage.setItem('submissionId', restoreSubmissionId)
          const search = surveyQuery ? `?${surveyQuery}` : ''
          navigate(`/survey/${encodeURIComponent(restoreRoute)}${search}`, { replace: true })
        } else {
          setError(error?.message || 'Unknown error')
        }
      }
    }
    claim()
  }, [restoreSubmissionId, restoreCode, restoreSurveyId, restoreRoute, surveyQuery, userReady])

  if (error) {
    return <LoadingSplash message="Sorry, there was an error restoring your survey." />
  }

  return <LoadingSplash message="Restoring survey..." />
}
